"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _default = {
  fetchUsers: function fetchUsers() {
    var portalId = _hubspot.default.get();

    var request = {
      hubId: portalId,
      active: true,
      activePermissions: true,
      visible: true
    };
    return _apiClient.default.get('users/v2/app/hub-users', {
      query: request
    });
  }
};
exports.default = _default;
module.exports = exports.default;